import { render } from "./table-grid-popup.vue?vue&type=template&id=c6e80872"
import script from "./table-grid-popup.vue?vue&type=script&lang=js"
export * from "./table-grid-popup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__